import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { TrackLeadCardComponent } from './track-lead-card/track-lead-card.component';
import { TrackLeadCardBottomChipComponent } from './track-lead-card-bottom-chip/track-lead-card-bottom-chip.component';
import { NavigatorComponent } from './navigator/navigator.component';
import { AngularMaterialModule } from '@angular-material';
import { MenuFiltersComponent } from './menu-filters/menu-filters.component';
import { SortFiltersComponent } from './sort-filters/sort-filters.component';
import {
  TrackLeadDialogComponent,
  QuoteDialogComponent,
  DatetimeGridDialogComponent,
  AutomationsDialogComponent,
  MultiBusinessLineDialogComponent,
} from './dialogs';
import { AvatarBoxComponent } from './avatar-box/avatar-box.component';
import { NanaykunaUiKitModule } from '@nanaykuna-ui-kit';
import { AccordionCardComponent } from './accordion-card/accordion-card.component';
import { AccordionCotizationCardComponent } from './accordion-cotization-card/accordion-cotization-card.component';
import { ProbabilityChipComponent } from './probability-chip/probability-chip.component';
import { UserChipComponent } from './user-chip/user-chip.component';
import { ButtonComponent } from './button/button.component';
import { ProductOptionChipComponent } from './product-option-chip/product-option-chip.component';
import { BtnVerticalMenuComponent } from './btn-vertical-menu/btn-vertical-menu.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ListMessageItemComponent } from './list-message-item/list-message-item.component';
import { MessageItemComponent } from './message-item/message-item.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@directives';
import {
  DocumentFieldComponent,
  EmailFieldComponent,
  FileFieldComponent,
  IdentityFieldComponent,
  MultimediaFieldComponent,
  PhoneFieldComponent,
  ProductFieldComponent,
  TextFieldComponent,
  TopbarFieldComponent,
  TextSelectFieldComponent,
} from './form-fields';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';
import { OrderItemComponent } from './order-item/order-item.component';
import { RecurringCustomerChipComponent } from './recurring-customer-chip/recurring-customer-chip.component';
import { provideNativeDateAdapter } from '@angular/material/core';
import { LocationFieldComponent } from './form-fields/location-field/location-field.component';
import { ChartTopLegendComponent } from './chart-top-legend/chart-top-legend.component';
import { ConversionRateCardComponent } from './conversion-rate-card/conversion-rate-card.component';
import { PercentIndicatorComponent } from './percent-indicator/percent-indicator.component';
import { SpeedometerCardComponent } from './speedometer-card/speedometer-card.component';
import {
  BaseChartDirective,
  provideCharts,
  withDefaultRegisterables,
} from 'ng2-charts';
import { MenuTooltipComponent } from './menu-tooltip/menu-tooltip.component';
import { QuickAnswersDialogComponent } from './dialogs/quick-answers-dialog/quick-answers-dialog.component';
import { LeadSearchComponent } from './lead-search/lead-search.component';
import { UnarchiveAlertComponent } from './unarchive-alert/unarchive-alert.component';
import { CommercialAgreementDialogComponent } from './dialogs/commercial-agreement-dialog/commercial-agreement-dialog.component';
import { NoteFieldComponent } from './form-fields/note-field/note-field.component';
import { MatSelectModule } from '@angular/material/select';
import { AudioRecordingFieldComponent } from './form-fields/audio-recording-field/audio-recording-field.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SelectComponent } from './select/select.component';
import { RankingItemComponent } from './ranking-item/ranking-item.component';
import { IndicatorsComponent } from './indicators/indicators.component';
import { DashboardMapComponent } from './dashboard-map/dashboard-map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { DashboardFunnelComponent } from './dashboard-funnel/dashboard-funnel.component';
import { DatetimeCalendarComponent } from './datetime-calendar/datetime-calendar.component';
import { BulkMessageModalComponent } from './dialogs/bulk-message-modal/bulk-message-modal.component';
import { BusinessLineShippingDateComponent } from './business-line-shipping-date/business-line-shipping-date.component';
import { AddProductMultiCategoryComponent } from './add-product-multi-category/add-product-multi-category.component';
import { ActionButtonComponent } from './action-button/action-button.component';
import { SectionHeaderComponent } from './section-header/section-header.component';
import { FieldLabelWrapperComponent } from './field-label-wrapper/field-label-wrapper.component';
import { CommercialAgreementStatusComponent } from './commercial-agreement-status/commercial-agreement-status.component';

@NgModule({
  declarations: [
    NavigatorComponent,
    TrackLeadCardComponent,
    TrackLeadCardBottomChipComponent,
    ProductOptionChipComponent,
    MenuFiltersComponent,
    SortFiltersComponent,
    TrackLeadDialogComponent,
    MultiBusinessLineDialogComponent,
    AvatarBoxComponent,
    AccordionCardComponent,
    AccordionCotizationCardComponent,
    ProbabilityChipComponent,
    UserChipComponent,
    ButtonComponent,
    BtnVerticalMenuComponent,
    ListMessageItemComponent,
    MessageItemComponent,
    DocumentFieldComponent,
    EmailFieldComponent,
    PhoneFieldComponent,
    ProductFieldComponent,
    TextFieldComponent,
    MultimediaFieldComponent,
    TopbarFieldComponent,
    FileFieldComponent,
    AudioRecordingFieldComponent,
    ImageGalleryComponent,
    IdentityFieldComponent,
    OrderItemComponent,
    RecurringCustomerChipComponent,
    LocationFieldComponent,
    QuoteDialogComponent,
    ChartTopLegendComponent,
    ConversionRateCardComponent,
    PercentIndicatorComponent,
    SpeedometerCardComponent,
    MenuTooltipComponent,
    DatetimeGridDialogComponent,
    TextSelectFieldComponent,
    QuickAnswersDialogComponent,
    LeadSearchComponent,
    UnarchiveAlertComponent,
    CommercialAgreementDialogComponent,
    NoteFieldComponent,
    SelectComponent,
    RankingItemComponent,
    IndicatorsComponent,
    DashboardMapComponent,
    DashboardFunnelComponent,
    DatetimeCalendarComponent,
    AutomationsDialogComponent,
    BulkMessageModalComponent,
    BusinessLineShippingDateComponent,
    AddProductMultiCategoryComponent,
    ActionButtonComponent,
    SectionHeaderComponent,
    FieldLabelWrapperComponent,
    CommercialAgreementStatusComponent,
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    NanaykunaUiKitModule,
    NgxSkeletonLoaderModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    BaseChartDirective,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    GoogleMapsModule,
  ],
  exports: [
    NavigatorComponent,
    TrackLeadCardComponent,
    ProductOptionChipComponent,
    MenuFiltersComponent,
    SortFiltersComponent,
    TrackLeadDialogComponent,
    MultiBusinessLineDialogComponent,
    AvatarBoxComponent,
    AccordionCardComponent,
    AccordionCotizationCardComponent,
    ProbabilityChipComponent,
    UserChipComponent,
    ButtonComponent,
    BtnVerticalMenuComponent,
    ListMessageItemComponent,
    MessageItemComponent,
    DocumentFieldComponent,
    EmailFieldComponent,
    PhoneFieldComponent,
    ProductFieldComponent,
    TextFieldComponent,
    MultimediaFieldComponent,
    TopbarFieldComponent,
    FileFieldComponent,
    ImageGalleryComponent,
    IdentityFieldComponent,
    OrderItemComponent,
    RecurringCustomerChipComponent,
    QuoteDialogComponent,
    ChartTopLegendComponent,
    ConversionRateCardComponent,
    PercentIndicatorComponent,
    SpeedometerCardComponent,
    MenuTooltipComponent,
    DatetimeGridDialogComponent,
    TextSelectFieldComponent,
    LeadSearchComponent,
    UnarchiveAlertComponent,
    CommercialAgreementDialogComponent,
    NoteFieldComponent,
    LocationFieldComponent,
    SelectComponent,
    RankingItemComponent,
    IndicatorsComponent,
    DashboardMapComponent,
    DashboardFunnelComponent,
    DatetimeCalendarComponent,
    BusinessLineShippingDateComponent,
    AddProductMultiCategoryComponent,
    ActionButtonComponent,
    SectionHeaderComponent,
    FieldLabelWrapperComponent,
    CommercialAgreementStatusComponent,
  ],
  providers: [
    provideNativeDateAdapter(),
    provideCharts(withDefaultRegisterables()),
    DatePipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ComponentsModule {}
